import * as React from "react";
import {Dispatch} from "redux";
import {RouteComponentProps, withRouter} from "react-router";
import {acceptToS, logOut} from "../../store/action/user/user";
import {connect} from "react-redux";
import {OnSuccess} from "../../store/action/actionHelpers";
import Toast from "../helper/Toast";
import UserConsentData, {UserConsentType} from "../../model/user/UserConsentData";
import "./termsOfServicePage.scss";
import ButtonTertiary from "../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import ButtonPrimary from "../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";

const logo = require('../../../resources/hiber/img/dg-logo-big-green.png');


interface IDispatchProps {
	/**
	 * Log out user action.
	 */
	logOut: () => void;
	/**
	 * Accept ToS user action
	 * @param {OnSuccess} onSuccess
	 */
	acceptToS: (data: UserConsentData, onSuccess: OnSuccess) => void;
}

type Props = IDispatchProps & RouteComponentProps<IDispatchProps>;

interface IState {
	/**
	 * Indicates if accept ToS action is in progress.
	 */
	accceptActionloading: boolean
	/**
	 * Indicates if decline ToS action is in progress.
	 */
	declineActionloading: boolean
}

class TermOfServicePage extends React.Component<Props, IState> {
	constructor(props: Props, state: IState) {
		super(props, state);
		this.state = {accceptActionloading: false, declineActionloading: false};
		this.onAccept = this.onAccept.bind(this);
		this.onDecline = this.onDecline.bind(this);
		this.onSucces = this.onSucces.bind(this);
	}

	render() {
		return (
			<div className={"c-tos-page"}>
				<div className="c-tos-page_content">
					<img src={logo} className={"c-tos-page_content_logo"}/>
					<div className={"c-tos-page_content_text"}>
						Phasellus et rutrum magna. Aliquam id sapien vestibulum, molestie diam in, malesuada turpis. Sed
						et nisl id nisl vehicula tempor ut facilisis eros. Mauris bibendum nulla sed dui auctor tincidunt.
						Pellentesque eget tortor eros. Aliquam sollicitudin sapien et risus sagittis molestie. Quisque
						faucibus massa nec est feugiat rhoncus. In hac habitasse platea dictumst. Nulla dapibus erat et
						ultricies aliquam.<br/>
						<a href="https://www.hiber.com/terms-conditions/" target={"_blank"}>Terms of Service</a>
					</div>
					<div className="c-tos-page_content_buttons">
						<ButtonTertiary label={"Decline"}
										onClick={this.onDecline}
										disabled={this.state.accceptActionloading}/>
						<ButtonPrimary label={"Accept"} onClick={this.onAccept}
									   isLoading={this.state.accceptActionloading}
									   disabled={this.state.declineActionloading}/>
					</div>
				</div>
			</div>
		);
	}

	/**
	 * Accept ToS action
	 */
	onAccept() {
		this.setState({accceptActionloading: true});
		this.props.acceptToS(new UserConsentData(UserConsentType.Crm), this.onSucces);
	}

	/**
	 * Decline ToS action
	 */
	onDecline() {
		this.setState({declineActionloading: true});
		this.props.logOut();
	}

	/**
	 * On success callback
	 */
	onSucces() {
		this.setState({accceptActionloading: false});
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		logOut: () => dispatch(logOut()),
		acceptToS: (data: UserConsentData, onSuccess: OnSuccess) => dispatch(
			acceptToS(data, onSuccess,
				() => {Toast.error("Sorry, something went wrong. Try again later.", "Accept terms of service")}))
	}
}

export default withRouter(connect(null, mapDispatchToProps)(TermOfServicePage));